<template>
  <div class="main">
    <dd-header></dd-header>
    <div class="content_main">
      <h1>提案リスト</h1>
      <section class="propose_list">
        <div class="propose">
          <div>
            {{ID}}
          </div>
          <div>
            <div>
              <span>提案日</span>
              <span></span>
            </div>
            <div>
              <span>提案カグラー</span>
              <span></span>
            </div>
          </div>
          <div>
            {{price}}
          </div>
        </div>
      </section>
    </div>
    <dd-footer></dd-footer>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import {API_URL} from '../constants/App'
// import * as App from '../utils/App'
// import {SO_STORAGE_KEY} from '../constants/App'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  name: 'UploadConfirm',
  components: {
    'dd-header': Header,
    'dd-footer': Footer
  },
  data () {
    return {
      inputForm: {}
    }
  },
  computed: {
  },
  methods: {
    proposeList: function () {
      let payload = {
        userId: 1
      }
      axios.post(API_URL.SKETCH + '/propose-list', payload
      ).then(response => {
      }).catch(error => {
        Api.handleError(error)
      })
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style src="../css/top.scss" lang="scss" scoped></style>
<style src="../css/main.scss" lang="scss" scoped></style>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/upload.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/ProposeList.vue